import { Component, OnInit, Input, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';

interface INameable {
    name: string;
    canEditMetadata: boolean;
}

interface IRenamer {
    rename(entity: INameable);
}

// Simple component that displays an entity's name (eg a FormInstance) and provides a way to edit it
// The entity @Input needs to conform to the INameble interface - i.e. it just needs a writeable name property
// the renameService @Input meeds to conform to the IRenamer interface - i.e. it needs a rename method
@Component({
    selector: 'app-entity-name-editor',
    templateUrl: './entity-name-editor.component.html',
    styleUrls: ['./entity-name-editor.component.scss'],
    standalone: false
})
export class EntityNameEditorComponent implements OnInit {
    private editingName: boolean;

    @Input() entity: INameable;
    @Input() renameService: IRenamer;
    @Input() entityType: string;
    @Input() suffix: string;
    @Input() maxLength: number;

    @Output() done: EventEmitter<INameable> = new EventEmitter<INameable>(); 

    @ViewChild('entityNameInput') entityNameInput: ElementRef;

    private originalName: string;

    constructor() { }

    ngOnInit(): void {
    }

    public get EditingName(): boolean {
        return this.editingName;
    }
    public set EditingName(value: boolean) {
        this.editingName = value;
    }

    public get Entity(): INameable {
        return this.entity;
    }

    public get EntityType(): string {
        return this.entityType;
    }

    public get UserCanEditName(): boolean {
        return this.entity.canEditMetadata;
    }

    public renameEntity() {
        this.editingName = true;
        this.originalName = this.entity.name;
        setTimeout(() => {
            this.entityNameInput.nativeElement.focus();
            this.entityNameInput.nativeElement.select();
        }, 0);
    }

    public cancelRename() {
        this.editingName = false;
        this.entity.name = this.originalName;
    }
    
    public save(): void {
        this.entity.name = this.entity.name.trim();
        if (this.maxLength && this.entity.name.length > this.maxLength) {
            alert(`Name cannot be longer than ${this.maxLength} characters.\nThe name you supplied contains ${this.entity.name.length} characters. \nPlease edit and try again.`);
            return;
        }
        this.renameService.rename(this.entity).then(x => {
            this.editingName = false;
            this.done.emit(x);
        });
    }
}
